<template>
  <div class="rt-header-icon-wrapper">
    <rt-icon :name="icon" size="34"></rt-icon>
  </div>
</template>

<script>
export default {
  name: 'RtHeaderIcon',
  props: {
    icon: {
      type: String,
      default: ''
    }
  }
};
</script>
<style lang="less">
.rt-header-icon-wrapper {
  padding: 7px;
  background: #ff992c;
  color: #fff;
  border-radius: 2px;
}
</style>



// WEBPACK FOOTER //
// rtHeaderIcon.vue?08acd245